<template>
  <ApplyDecision
    v-bind="props"
    component-type="ApplyNoOfferDecision"
    decision="nooffer"
    :component="component"
  />
</template>

<script setup lang="ts">
  import { ApplyDecisionProps } from "@/models/apply/apply-models"
  import ApplyDecision from "@/components/apply/ApplyDecision.vue"
  import { useLocalizedComponents } from "@versatile-credit-apply/components"

  const props = defineProps<ApplyDecisionProps>()

  const component = useLocalizedComponents(() => props.response, {
    ads_standard: () =>
      import("@/providers/ads_standard/components/AdsNoOfferDecision.vue"),
    aff_standard: () =>
      import("@/providers/aff_standard/components/AffNoOfferDecision.vue"),
    bread_standard: () =>
      import("@/providers/bread_standard/components/BreadNoOfferDecision.vue"),
    fortiva_standard: () =>
      import(
        "@/providers/fortiva_standard/components/FortivaNoOfferDecision.vue"
      ),
    genesis_standard: () =>
      import(
        "@/providers/genesis_standard/components/GenesisNoOfferDecision.vue"
      ),
    hfd_standard: () =>
      import("@/providers/hfd_standard/components/HFDNoOfferDecision.vue"),
    lendingclub_standard: () =>
      import(
        "@/providers/lendingclub_standard/components/LendingClubNoOfferDecision.vue"
      ),
    proceed_standard: () =>
      import(
        "@/providers/proceed_standard/components/ProceedNoOfferDecision.vue"
      ),
    synchrony_standard: () =>
      import(
        "@/providers/synchrony_standard/components/SynchronyNoOfferDecision.vue"
      ),
  })
</script>
